module.exports = __webpack_public_path__ + "img/5-en.d2aeb3be.jpg";